import { render, staticRenderFns } from "./ProductVariantSelector.vue?vue&type=template&id=4b748754&scoped=true&"
import script from "./ProductVariantSelector.vue?vue&type=script&lang=js&"
export * from "./ProductVariantSelector.vue?vue&type=script&lang=js&"
import style0 from "./ProductVariantSelector.vue?vue&type=style&index=0&id=4b748754&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b748754",
  null
  
)

export default component.exports